import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.metadata = {
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      pb: [6, null, 8],
    };

    this.title = {
      variant: 'text.h2',
      minHeight: ['36px', '40px'],
      fontSize: ['24px', '40px'],
      lineHeight: 'normal',
      fontWeight: ['400', '300'],
      letterSpacing: ['-0.12px', '-0.03em'],
    };

    this.variant = {
      color: 'mediumDarkGray',
      fontSize: ['14px', 4],
      minHeight: '22px',
    };

    this.priceAfterpayWrapper = {
      variant: 'flex.row.start.center',
      flexWrap: 'wrap',
      mt: 4,
    };

    this.price = {
      text: 'text.h2',
      minHeight: 40,
    };
  })()
);
